import React from "react";
import {Grid, withStyles, Tooltip, Button} from "@material-ui/core";
import style from "./styles";
import Badge from '@material-ui/core/Badge';
import {withFb} from '../../contexts/FbProvider';

function IconButtonBuilder(props) {
    const { fieldSchema: schema, classes, form} = props;
    const Icon = schema.icon;
    if (schema.hide)
        return <></>
    const Bt = <Badge overlap="rectangular"
                      badgeContent={schema.badge} color={'default'}
                      className={classes.iconButtonBadge}
                      anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                      }}>
        <Button className={classes.iconButton} fullWidth variant={'outlined'} onClick={(e) => schema.onClick(props, form)}>
            <Icon/>
            <span className={'text-icon-button'}>{schema.label}</span>
        </Button>
    </Badge>
    return <Grid item {...schema.props} {...(schema.sizes ?? {})}>
        {
            schema.tooltip ? <Tooltip
                title={schema.label}
                placement={'top'}
                enterDelay={300}>
                {
                    Bt
                }
            </Tooltip> : Bt
        }
    </Grid>;
}


export default withStyles(style)(withFb(IconButtonBuilder));
